module.exports = __webpack_public_path__ + "img/reference20.cc2280e7.jpg";